import React from 'react';
import { FormControl, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { CandleFrequency, CandleFrequencyOption } from '../types';

interface FrequencySelectorProps {
    selectedFrequency: CandleFrequency;
    availableFrequencies: CandleFrequencyOption[];
    onChange: (frequency: CandleFrequency) => void;
    disabled?: boolean;
}

export const FrequencySelector: React.FC<FrequencySelectorProps> = ({
    selectedFrequency,
    availableFrequencies,
    onChange,
    disabled = false,
}) => {
    const handleChange = (event: SelectChangeEvent<CandleFrequency>) => {
        onChange(event.target.value as CandleFrequency);
    };

    return (
        <FormControl size="small" disabled={disabled} sx={{ minWidth: 60, width: 'auto', flex: 'none' }}>
            <Select
                value={selectedFrequency}
                onChange={handleChange}
                variant="outlined"
                sx={{
                    '& .MuiSelect-select': {
                        padding: '2px 6px',
                        fontSize: '0.875rem',
                    },
                    height: 28,
                    width: 'auto',
                }}
            >
                {availableFrequencies.map((freq) => (
                    <MenuItem key={freq.value} value={freq.value}>
                        {freq.value}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
